import { MdGroup } from "react-icons/md";
import { statsAdminService } from "services/admin/statsService";
import { formatNumber, useDashboardQuery } from "../dashboard-utils";
import KpiCard from "./KpiCard";

const CustomersCount = ({ month }) => {
  const q = useDashboardQuery(["customers-count", month], async () => (await statsAdminService.getCustomersCount({ month })).data);

  return (
    <KpiCard
      icon={MdGroup}
      accent="blue"
      label="Клиенты"
      hint="Новые клиенты за выбранный период"
      to="/admin/customers/all"
      value={formatNumber(q.data)}
      loading={q.isLoading}
      fetching={q.isPlaceholderData}
      error={q.error}
      onRetry={q.refetch}
    />
  );
};

export default CustomersCount;
